module.exports = __webpack_public_path__ + "assets/img/7f2c7895ba3c088d8b923ec292d0a068.svg";